import React from "react";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router";
import messages from "./module/messages";
import classes from "./NavigationStepper.module.scss";
import { messagesPaths } from "./module/constants";

const NavigationStepper = (props: any) => {
  const { history } = props;
  const url = history.location.pathname;
  const initPath = url.split("/");
  const pathMessage = messagesPaths[initPath[1] as keyof typeof messagesPaths]
    ? messagesPaths[initPath[1] as keyof typeof messagesPaths]
    : "welcome";
  return (
    <React.Fragment>
      <div className={classes["navigation-stepper"]}>
        <FormattedMessage {...messages[pathMessage as keyof typeof messages]} />
      </div>
    </React.Fragment>
  );
};

export default withRouter(NavigationStepper);
